/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PageUserDTO } from '../models/PageUserDTO';
import type { PageUserSearchStatusDTO } from '../models/PageUserSearchStatusDTO';
import type { StatsDTO } from '../models/StatsDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomAdminPageResourceService {
    /**
     * Get users without an activated signaller profile
     * Retrieves a paginated list of users that are not signallers.
     * @returns PageUserDTO OK
     * @throws ApiError
     */
    public static getUsersWithoutSignaller({
        page,
        size = 10,
        sortBy = 'login',
        sortDir = 'asc',
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Page size
         */
        size?: number,
        /**
         * Sort by field
         */
        sortBy?: string,
        /**
         * Sort direction (asc/desc)
         */
        sortDir?: string,
    }): CancelablePromise<PageUserDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/admin/users-without-signaller',
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Get the statistics info
     * Retrieves the dto containing all stats info
     * @returns StatsDTO OK
     * @throws ApiError
     */
    public static getStats(): CancelablePromise<StatsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/admin/statistics',
        });
    }
    /**
     * Get inactive signallers
     * Retrieves a paginated list of inactive (only registered) signallers.
     * @returns PageUserDTO OK
     * @throws ApiError
     */
    public static getInactiveSignallers({
        page,
        size = 10,
        sortBy = 'dateCreate',
        sortDir = 'asc',
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Page size
         */
        size?: number,
        /**
         * Sort by field
         */
        sortBy?: string,
        /**
         * Sort direction (asc/desc)
         */
        sortDir?: string,
    }): CancelablePromise<PageUserDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/admin/signallers/inactive',
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Get active signallers
     * Retrieves a paginated list of active signallers.
     * @returns PageUserDTO OK
     * @throws ApiError
     */
    public static getActiveSignallers({
        page,
        size = 10,
        sortBy = 'dateCreate',
        sortDir = 'asc',
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Page size
         */
        size?: number,
        /**
         * Sort by field
         */
        sortBy?: string,
        /**
         * Sort direction (asc/desc)
         */
        sortDir?: string,
    }): CancelablePromise<PageUserDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/admin/signallers/active',
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Search users by email with status
     * Search users and return their signaller status.
     * @returns PageUserSearchStatusDTO OK
     * @throws ApiError
     */
    public static searchUsers({
        email,
        page,
        size = 10,
        sortBy = 'email',
        sortDir = 'asc',
    }: {
        email: string,
        /**
         * Page number
         */
        page?: number,
        /**
         * Page size
         */
        size?: number,
        /**
         * Sort by field
         */
        sortBy?: string,
        /**
         * Sort direction (asc/desc)
         */
        sortDir?: string,
    }): CancelablePromise<PageUserSearchStatusDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/admin/search-users',
            query: {
                'email': email,
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
}
